import { FC } from "react";
import { observer } from "mobx-react-lite";
import { SessionsListPageList } from "./components/sessions-list-page-list";
import { AppearAnimator, MDSFadeBottom, MDSPanelContainer } from "@/mds";
import { SessionsListPageHeader } from "./components/sessions-list-page-header";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import styled from "@emotion/styled";

interface SessionsListPageProps {}

export const SessionsListPage: FC<SessionsListPageProps> = observer(() => {
  const page = useTabPageStore("sessionsListPage");
  page.useEffects();

  return (
    <PageWrapper visible={page.subscriptionInitialized}>
      <SessionsListPageHeader />
      <MDSPanelContainer>
        <SessionsListPageList />
        <MDSFadeBottom />
      </MDSPanelContainer>
    </PageWrapper>
  );
});

const PageWrapper = styled(AppearAnimator)({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});
